export class Observable<P> {
  private observers: ((payload: P) => void)[] = []

  subscribe(observer: (payload: P) => void) {
    this.observers.push(observer)
  }

  unsubscribe(observer: (payload: P) => void) {
    this.observers = this.observers.filter(element => element !== observer)
  }

  notify(payload: P) {
    this.observers.forEach(observer => {
      observer(payload)
    })
  }
}
